import "../css/reset.scss";
import "../css/main.scss";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import smoothscroll from "smoothscroll-polyfill";
import store from "./store/configStore";
import Logger from "./utils/Logger";
import mode from "./utils/mode";
import g from "./utils/globals";
import api from "./utils/api";
import cookies from "./utils/cookies";
import dom from "./utils/dom";
import { setFeatures } from "./utils/features";
import { queryDevice } from "./utils/queryDevice";
import asyncComponent from "./components/hoc/asyncComponent";
const EditMode = asyncComponent(() => import("./EditMode"));
/* eslint-disable max-statements */

const reExec = ({ serverData } = {}) => {
  if (serverData?.mktCategorySpot?.mkt2) {
    window.__mkt2_init();
  }
};

export const exec = ({ storiesApi, controller, customPredicates = {} }) => {
  const logger = new Logger(__filename);

  smoothscroll.polyfill();

  const zara = window.zara || { appConfig: null, mkt: { require: null } };
  if (!zara.mkt) {
    zara.mkt = {
      require: null,
    };
  }
  zara.mkt.require = window._zaraRequire || window.require || null;

  if (zara.appConfig?.store?.sharingMethods) {
    g.setGlobals({ sharingMethods: zara.appConfig.store.sharingMethods });
  }

  if (storiesApi) {
    window.storiesApi = storiesApi;
  }

  // SET GLOBALS
  g.setGlobals({ controller, customPredicates });

  const resolveBundlePath = bundle => {
    const re = new RegExp(`${bundle}=(.*?);`);
    const cookieValue = re.test(document.cookie) && RegExp.$1;
    const path = (() => {
      switch (false) {
        case window.location.hostname !== "localhost":
          return "";
        case typeof cookieValue !== "string":
          return cookieValue;
        default:
          return g.staticContent;
      }
    })();
    return `${path}/mkt/dist/`;
  };

  __webpack_require__.p = resolveBundlePath("edge2");

  // SET FEATURES
  setFeatures();

  let main = document.getElementById("main");
  // NOTE: Some channel may not include a #main element
  if (!main) {
    main = document.createElement("div");
    main.id = "main";
    document.body.appendChild(main);
  }
  let css = document.getElementById("mkt-css");
  let js = document.getElementById("mkt-js");
  const edgeVersion = /edge=(.*?);/.test(document.cookie) && RegExp.$1;

  document.querySelectorAll("script").forEach(jsTag => {
    if (/mkt2\.js/.test(jsTag.src)) {
      js = jsTag;
    }
  });

  document.querySelectorAll("link").forEach(cssTag => {
    if (/mkt2\.css/.test(cssTag.href)) {
      css = cssTag;
    }
  });

  const mktLegacyMode = typeof webpackJsonpmkt !== "undefined";

  const passThrough = fn => {
    fn();
  };

  let initCallback = !document.getElementById("mkt-js")
    ? passThrough
    : g.channels.desktop
    ? zara.extensions.push.bind(zara.extensions)
    : g.channels.mobile
    ? zara.behaviour.push.bind(zara.behaviour)
    : passThrough;

  if (mode("naked")) {
    logger.log("naked!");
    css.remove();
    initCallback = () => {};
  }

  const loadStyles = (src, id) => {
    if (!css) {
      let link = document.querySelector(`#${id}-styles`);
      if (link) link.remove();
      link = document.createElement("link");
      link.id = `#${id}-styles`;
      link.rel = "stylesheet";
      link.type = "text/css";
      link.href = src;
      link.media = "all";
      document.head.appendChild(link);
    }
  };

  if (g.editMode) {
    css = document.createElement("link");
    css.href = `https://use.fontawesome.com/releases/v5.8.2/css/all.css`;
    css.setAttribute("rel", "stylesheet");
    css.setAttribute("type", "text/css");
    css.setAttribute("crossOrigin", "anonymous");
    css.setAttribute("integrity", "sha384-oS3vJWv+0UjzBfQzYUhtDYW+Pj2yciDJxpsK1OYPAYjqT085Qq/1cq5FLXAZQ7Ay");
    document.head.appendChild(css);
  }

  loadStyles(`${__webpack_require__.p}/mkt2.css?ts=${g?.timestamp || Number(new Date())}`, "mkt2-css");

  if (process.env.NODE_ENV === "production" && edgeVersion) {
    logger.log("edge version!");
    js.remove();

    css = document.createElement("link");

    const ts = Number(new Date());

    js = document.createElement("script");
    js.type = "text/javascript";
    js.src = `${edgeVersion}/mkt/dist/mkt2.js?ts=${ts}`;
    document.head.appendChild(js);
    initCallback = () => {};
  }

  const editModeInit = (options = {}) => {
    if (!g.localhost) {
      api.init();
    }
    const route = handler => {
      window.__contentsHandler = handler;
    };
    ReactDOM.render(
      <Provider store={store}>
        <EditMode onPageChange={route} response={options.response} products={options.products} />
      </Provider>,
      main
    );
  };
  const init = (options = {}) => {
    const frontMain = document.querySelector("#main");
    const response = options.response;
    const products = options.products;
    import("./App").then(module => {
      const App = module.default;
      const environment = zara.appConfig || g.channel === "web" ? "desktop" : g.channel;
      if (g.channel && g.storeCode) {
        switch (environment) {
          case "desktop":
            if (g.editMode && !g.localhost) {
              zara.mkt.require(
                ["plugins/router/engine", "plugins/url-builder", "plugins/events-manager"],
                (Router, urlBuilder, Manager) => {
                  window.Manager = Manager;
                  api.setApi({ urlBuilder });
                  window.zara.mkt.cookies = cookies;
                  editModeInit(options);
                }
              );
            } else if (g.editMode && g.localhost) {
              window.Manager = {};
              editModeInit(options);
            } else {
              zara.mkt.require(
                ["plugins/router/engine", "plugins/url-builder", "plugins/events-manager", "plugins/section-persistence"],
                (Router, urlBuilder, Manager, sectionPersistence) => {
                  dom.flushBodyClasses();
                  // NOTE: If "desktop" didn"t remove main child elements we would just change inner state to rerender
                  // const route = (changePageHandler) => {
                  //   Router.registerMiddleware("beforeShow", changePageHandler);
                  // };
                  // ReactDOM.render(<App onPageChange={route} response={response} products={products}/>, main);
                  window.Manager = Manager;
                  Manager.on(Manager.types.NAVIGATION_DONE, reExec);
                  api.setApi({ urlBuilder });
                  window.zara.mkt.cookies = cookies;
                  api.init();
                  window.sectionPersistence = sectionPersistence;
                  const mount = () => {
                    let main = document.querySelector("#mkt-wrapper");
                    if (main) main.remove();
                    main = document.createElement("div");
                    // Se le esta inyectando en linea un min-height que hace que se rompa el diseño. Comprobar si viene de frontal
                    main.id = "mkt-wrapper";
                    main.setAttribute("dir", "ltr");

                    frontMain.prepend(main);
                    // queryDevice will change app configuration in debug mode by querystring
                    queryDevice();
                    ReactDOM.render(
                      <Provider store={store}>
                        <App response={response} products={products} />
                      </Provider>,
                      main
                    );
                    Router.registerMiddleware("afterRequest", () => ReactDOM.unmountComponentAtNode(main));
                  };
                  // if (mktLegacyMode) {
                  //   window.__mkt2_init = mount;
                  // } else {
                  //   Router.registerMiddleware("beforeShow", mount);
                  // }
                  mount();
                }
              );
            }
            break;
          case "mobile":
            zara.mkt.require(["plugin/url-builder", "manager", "plugin/section-persistence"], (urlBuilder, Manager, sectionPersistence) => {
              dom.flushBodyClasses();
              api.setApi({ urlBuilder });
              window.Manager = Manager;
              window.sectionPersistence = sectionPersistence;
              window.zara.mkt.cookies = cookies;
              api.init();
              // Mobile main is different
              dom.addBodyClass("home-mobile-module");
              main = document.getElementById("home-mobile-wrapper");
              if (!main) {
                main = document.createElement("div");
                main.id = "home-mobile-wrapper";
                main.setAttribute("dir", "ltr");
                frontMain.prepend(main);
              }
              if (g.editMode) {
                const route = handler => {
                  window.__contentsHandler = handler;
                };
                ReactDOM.render(
                  <Provider store={store}>
                    <EditMode onPageChange={route} response={response} products={products} />
                  </Provider>,
                  main
                );
              } else {
                ReactDOM.render(
                  <Provider store={store}>
                    <App response={response} products={products} />
                  </Provider>,
                  main
                );
              }
            });
            break;
          case "standalone": {
            const route = handler => {
              window.__contentsHandler = handler;
            };
            const queryLang = window.location.search.match("langCode=(.*)");
            const clientLangCode = queryLang ? queryLang[1] : window.navigator.language || navigator.userLanguage;
            const supportedLanguage = g.supportedLocales.find(l => l.langCode === clientLangCode);
            if (supportedLanguage && clientLangCode && g.langCode !== clientLangCode) {
              g.changeLanguage(supportedLanguage);
            }

            ReactDOM.render(
              <Provider store={store}>
                <App onPageChange={route} response={response} products={products} />
              </Provider>,
              main
            );
            break;
          }
          case "apps": {
            const route = handler => {
              window.__contentsHandler = handler;
            };
            ReactDOM.render(
              <Provider store={store}>
                <div id="home-mobile-wrapper" dir="ltr">
                  <App onPageChange={route} response={response} products={products} />
                </div>
              </Provider>,
              main
            );
            break;
          }
          case "minip": {
            const route = handler => {
              window.__contentsHandler = handler;
            };
            // TODO: pongo class minip porque muchos contenidos y css penden de mobile
            ReactDOM.render(
              <Provider store={store}>
                <div id="home-mobile-wrapper" dir="ltr" className="minip">
                  <App onPageChange={route} response={response} products={products} />
                </div>
              </Provider>,
              main
            );
            break;
          }
          default:
            throw new Error(`Unknown channel: ${g.channel}`);
        }
        return true;
      }
    });
  };
  if (!document.body.classList.contains("no-mkt")) {
    if (mktLegacyMode) {
      init();
    } else {
      initCallback(init);
    }
  }
  if (window.zara?.viewPayload?.sliderSpot?.content?.features?.snowflakes?.enabled) {
    const path = `${window.zara.mkt.staticContent}/contents/aw20-snowflakes/index.js`;
    const js = document.createElement("script");
    js.type = "text/javascript";
    js.src = path;
    document.head.appendChild(js);
  }
};
